export default __webpack_public_path__ + "static/media/info.c8e0d597.svg";